/* eslint-disable no-useless-escape */

const rules = {}

const linkRegex = /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/gim
const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\.\_\~\]\[\}\{\)\(\,\:\?\'\/\\\+!@#\$%\^&\*])(?=.{8,})/
const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
const ibanRegex = /^[0-9]{26,26}$/
const postalCodeRegex = /^[0-9]{2}-[0-9]{3}$/

rules.required = (val) => {
    if ((typeof val === 'boolean' && val) || (typeof val === 'string' && val?.length >= 2) || typeof val === 'object') {
        return true
    }
    return 'This field is required.'
}

rules.email = (val) => {
    if (val && val.match(emailRegex)) {
        return true
    }
    return 'This field must be a valid email.'
}

rules.link = (val) => {
    if (val && val.match(linkRegex)) {
        return true
    }
    return 'This field must be a link.'
}

rules.iban = (val) => {
    if (val && val.match(ibanRegex)) {
        return true
    }
    return 'This field must be a 26 digit account number.'
}

rules.password = (val) => {
    if (val && val.match(passRegex)) {
        return true
    }
    return 'Password must be at least 8 characters long and must contain at least 1 number, 1 special character and 1 capital letter.'
}

rules.postalCode = (val) => {
    if (val && val.match(postalCodeRegex)) {
        return true
    }
    return 'This field must be a postal code format (XX-XXX)'
}

const validateFiled = (propsRules, val) => {
    if (!propsRules || !propsRules.length) return true
    for (let i = 0; i < propsRules.length; i += 1) {
        const rule = propsRules[i]
        if (rule in rules) {
            if (rules[rule](val) !== true) {
                return rules[rule](val)
            }
        }
    }
    return true
}

const validateLogic = (props, modelState, input, internalError, emit) => {
    const valid = validateFiled(props.rules, modelState.value)
    if (valid !== true) {
        // eslint-disable-next-line no-param-reassign
        internalError.value = valid
    } else {
        // eslint-disable-next-line no-param-reassign
        internalError.value = null
    }
    let parent = input.value.parentElement
    while (!parent.classList.contains('tl-form-validator') || !parent.id === 'tl-app') {
        parent = parent.parentElement
    }
    parent.dispatchEvent(new CustomEvent('validated', { detail: valid }))
    emit('validated', valid)
}

export default () => ({
    rules,
    validateFiled,
    validateLogic,
})
